export class NotesModel {
    private readonly _notes?: string;

    /**
     * @constructor NotesModel
     * @param note - The notes field.
     * @description This class is used to manage the notes field.
     */
    constructor(public readonly note?: string) {
        this._notes = note;
    }

    /**
     * @method notes
     * @description This method returns the notes field.
     * @returns {string | undefined} The notes field.
     */
    public get notes(): string | undefined {
        return this._notes;
    }
}